module.exports = __webpack_public_path__ + "static/img/1.6513d2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/zh/1.png
// module id = BF/z
// module chunks = 0